export interface ILayouts {
  selectedHouseId: number | undefined;
  selectedRoomsCount: ERoomsCount | undefined;
  data?: ILayout[];
}

export interface ILayoutsInfo {
  /** Текст c информацией о количестве планировок **/
  countText: string;
  /** Дефолтная комнатность **/
  defaultRoomValue: ERoomsCount;
  /** Список планировок для дефолтной комнатности **/
  layouts: ILayout[];
  /** Список комнат с доступными планировками **/
  roomsCountsByHouse: IRoomsCountsByHouse[];
  /** Признак наличия планировки с туром **/
  hasTour: boolean;
}

export interface IRoomsCountsByHouse {
  /** ID корпуса **/
  houseId?: number | null;
  /** Название корпуса **/
  houseName: string;
  /** Список возможных вариантов комнатности **/
  roomsCountList: ILayoutRoomCount[];
}

export interface ILayoutRoomCount {
  /** Есть ли квартиры с данной комнатностью **/
  isAvailable: boolean;
  /** Значение для отрисовки на фронте (например '1') **/
  roomTitle: string;
  /** Значение для отправки на бэкенд (напримем oneRoom) **/
  roomValue: ERoomsCount;
}

export interface ILayout {
  /** Изображение планировки **/
  image: ILayoutImage;
  /** Текст с информацией о комнатности и цене за квадратный метр **/
  roomsSquareMeterPriceText: string;
  /** Ссылка на выдачу **/
  searchButtonLink: string;
  /** Текст с информацией о площади и цене **/
  totalAreaPriceText: string;
  /** Площадь **/
  totalArea: string;
  /** Ссылка на тур vr net **/
  tourUrl?: string | null;
}

export interface ILayoutImage {
  /** URL превью **/
  fullUrl: string;
  /** URL исходного изображения **/
  thumbnailUrl: string;
}

export enum ERoomsCount {
  /**  **/
  FourPlusRoom = 'fourPlusRoom',
  /**  **/
  OneRoom = 'oneRoom',
  /**  **/
  Studio = 'studio',
  /**  **/
  ThreeRoom = 'threeRoom',
  /**  **/
  TwoRoom = 'twoRoom',
}

export enum ELayoutTypes {
  Layout = 'layout',
  Tour = 'tour',
}
